/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Modal_SubtitleInputs */

const en_cna_modal_subtitle = /** @type {(inputs: Cna_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You couldn't reach the customer (without going on site).`)
};

const ja_cna_modal_subtitle = /** @type {(inputs: Cna_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現場に行かずに顧客に連絡が取れませんでした。`)
};

const fr_cna_modal_subtitle = /** @type {(inputs: Cna_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez pas pu joindre le client (sans aller sur site).`)
};

const de_cna_modal_subtitle = /** @type {(inputs: Cna_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie konnten den Kunden nicht erreichen (ohne vor Ort zu fahren).`)
};

/**
* | output |
* | --- |
* | "You couldn't reach the customer (without going on site)." |
*
* @param {Cna_Modal_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_modal_subtitle = /** @type {((inputs?: Cna_Modal_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Modal_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_modal_subtitle(inputs)
	if (locale === "ja") return ja_cna_modal_subtitle(inputs)
	if (locale === "fr") return fr_cna_modal_subtitle(inputs)
	return de_cna_modal_subtitle(inputs)
});